import Base from './base';

class BrowseBrokers extends Base {
  getIssuerBrokers = (payload) => {
    return this.apiClient.get(`rfps`, payload);
  };
}

export default BrowseBrokers;
